import { environment } from './../environments/environment';
import { JL } from 'jsnlog';
import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';

import { AboutComponent } from './about/about.component';
import { AuthenticationService } from './shared/authentication.service';
import { CartService } from './cart/cart.service';
import { ClearHistoryComponent } from './clear-history/clear-history.component';
import { CourtCase } from './shared/court-case';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { EmailComponent } from './email/email.component';
import { EventService } from './shared/event.service';
import { HelpComponent } from './help/help.component';
import { PrintComponent } from './print/print.component';
import { SessionTimeoutService } from './shared/session-timeout.service';
import { SessionTimeoutWarningComponent } from './session-timeout-warning/session-timeout-warning.component';
import { RoutingHistoryService } from './shared/routing-history.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {

  caseViewIsVisible = false;

  public constructor(private authenticationService: AuthenticationService,
                     private cartService: CartService,
                     private router: Router,
                     private eventService: EventService,
                     private modalService: BsModalService,
                     private sessionTimeoutService: SessionTimeoutService,
                    private routingHistoryService: RoutingHistoryService) {

    sessionTimeoutService.initialize();

    // On a "clear history" event", route to home (landing component), clear cart
    eventService.clearHistoryRequested$.subscribe(() => {
      this.hideModalsIfPresent();
      this.cartService.empty();
      router.navigateByUrl('/');
    });

    this.configureLogger()

    // Manage caseViewIsVisible flag, so the template knows when to hide the "main content"
    this.router.events
      .filter(event => event instanceof NavigationEnd)
      .map(event => event as NavigationEnd) // done just to get proper type below
      .subscribe(event  => {
        this.caseViewIsVisible = event.urlAfterRedirects.indexOf('view:') !== -1;
        this.routingHistoryService.addCurrentUrl(event.urlAfterRedirects);
      });

    this.eventService.openAboutRequested$.subscribe(() => {
      this.openAboutModal();
    });
    this.eventService.impendingSessionTimeoutDetected$.subscribe(() => {
      this.openSessionTimeoutModal();
    });
    this.eventService.openHelpRequested$.subscribe(() => this.openHelpModal());
    this.eventService.openDisclaimerRequest$.subscribe((mode) => this.openDisclaimerModal(mode));
    this.eventService.openClearHistoryRequested$.subscribe(() => this.openClearHistoryModal());
    this.eventService.openEmailRequested$.subscribe(cases => {
      this.openEmailModal(cases);
    });
    this.eventService.openPrintRequested$.subscribe(cases => {
      this.openPrintModal(cases);
    });
  }

  private configureLogger(): void {
    // Create beforeSend handler
    const beforeSendHandler = (xhr) => {
      const token = this.authenticationService.getToken();
      if (!!token) {
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);
      } else {
        console.error(`Trying to log error, but we don't have a token.`);
      }
    };

    const appender = JL.createAjaxAppender('ciprs appender');
    appender.setOptions({
        'url': environment.proxyBaseUrl + 'client_log',
        'beforeSend': beforeSendHandler
    });

    JL().setOptions({
        'appenders': [appender]
    });
  }

  private openAboutModal() {
    this.modalService.show(AboutComponent, {class: 'modal-lg'});
  }

  private openSessionTimeoutModal() {
    this.modalService.show(SessionTimeoutWarningComponent, {class: 'modal-lg', backdrop: 'static'});
  }

  private openHelpModal() {
    this.modalService.show(HelpComponent, {class: 'modal-lg'});
  }

  private openDisclaimerModal(mode?: string) {
    const bsModalRef = this.modalService.show(DisclaimerComponent, {class: 'modal-lg'});
    bsModalRef.content.mode = mode;
  }

  private openClearHistoryModal() {
    this.modalService.show(ClearHistoryComponent);
  }

  private openEmailModal(cases: CourtCase[]) {
    const bsModalRef = this.modalService.show(EmailComponent, {class: 'modal-lg'});
    bsModalRef.content.cases = cases;
  }

  private openPrintModal(cases: CourtCase[]) {
    const bsModalRef = this.modalService.show(PrintComponent, {class: 'modal-lg'});
    bsModalRef.content.cases = cases;
  }

  private hideModalsIfPresent() {
    const modalCount = this.modalService.getModalsCount();
    for (let i = modalCount; i > 0; i--) {
      this.modalService.hide(i);
    }
  }

  /**
   * check on document:keydown event
   * 1) for enter key, trigger the click() event handler on the focused element
   * 2) ...
   * @param $event
   */
  @HostListener('document:keydown', ['$event'])
  onKeydown($event)  {
     // if keydown enter key (keycode == 13) and has focused element
     if ($event.which === 13 && document.hasFocus()) {
       console.log('current focused element: tag name= ' + document.activeElement.tagName + '| element id=' + document.activeElement.id  );
       // document.activeElement.click();  // while no click() property exists in document.activeElement
       if (!document.activeElement.id) {
         console.log('The focused element has no id, skip the click action');
         if (!environment.production) {
             // logging the whole element in non-production for debugging purpose
             console.log(document.activeElement);
         }
       } else {
         const activeEle: HTMLElement = document.getElementById(document.activeElement.id);
         activeEle.click();  // trigger the click event
       }
     }
   }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/app.component.ts